import React from "react";
import Stats from "./Stats";
import Navbar from "./Navbar";

export default function Hero() {
    return (
        <section className="bg-gradient-to-r from-green-900 via-[#12192C] to-green-900 text-white py-8 px-15">
            <Navbar/>
            <div className="max-w-6xl mx-auto flex flex-col mt-10 lg:flex-row items-center justify-between scale-x-110">
                <div className="space-y-5 max-w-xl">
                    <h1 className="font-bold text-5xl uppercase ">PORTA FACILISI <br />PLATEA ORNARE</h1>
                    <p className="text-gray-300">Consectetur lorem ut ut sit viverra diam mollis Pellentesque habitasse ultrices nunc aliquet quis. Ultrices sit orci ut tincidunt mauris eleifend sed. Euismod et.</p>
                    <button className="uppercase font-bold bg-lime-400 py-2 px-5">Je m'inscris</button>
                    <Stats/>
                </div>
                <img src="/hero.png" alt="hero" className="mt-10 lg:mt-0 w-80" />
            </div>
        </section>
    )
}